import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { SpendingTypeProps, TSpendingTypesState } from '../../types'
import { moneyFlowService } from '../../../services'
import { parseHttpError } from '../../utils'
import { parseSpendingTypes } from './utils'
import { selectors } from './selectors'
import { spendingTypesAdapter } from './adapter'
import { FetchCollectionParams, FetchCreatedAtParams, UpdateEntityProps } from '../../../services/_common'

const name = 'spendingTypes'

const initialState: TSpendingTypesState = {
    ...spendingTypesAdapter.getInitialState(),
    isFetching: false,
    totalItems: 0,
}

const fetch = createAsyncThunk(
    `${name}/fetch`,
    async (params: FetchCreatedAtParams & FetchCollectionParams | undefined) => {

        const order = params?.order || {'order[name]': 'asc'}

        return parseSpendingTypes(await moneyFlowService.fetchSpendingTypes({
            pagination: params?.pagination,
            page: params?.page,
            perPage: params?.perPage,
            ...order
        }))
    },
    {
        serializeError: parseHttpError
    }
)

const create = createAsyncThunk(
    `${name}/create`,
    async (spendingType: SpendingTypeProps) => {
        return await moneyFlowService.createSpendingType(spendingType)
    },
    {
        serializeError: parseHttpError
    }
)

const update = createAsyncThunk(
    `${name}/create`,
    async (spendingType: UpdateEntityProps<SpendingTypeProps>) => {
        return await moneyFlowService.updateSpendingType(spendingType)
    },
    {
        serializeError: parseHttpError
    }
)

const remove = createAsyncThunk(
    `${name}/remove`,
    async (id: string) => {
        return await moneyFlowService.removeSpendingType(id)
    },
    {
        serializeError: parseHttpError
    }
)

const slice = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(fetch.pending, (state) => {
                state.isFetching = true
                state.fetchError = undefined
            })
            .addCase(fetch.fulfilled, (state, action) => {
                state.isFetching = false
                state.totalItems = action.payload.totalItems
                spendingTypesAdapter.setAll(state, action.payload.entities)
            })
            .addCase(fetch.rejected, (state, action) => {
                state.isFetching = false
                state.fetchError = action.error
            })
})

export const spendingTypes = {
    name: slice.name,
    actions: {
        fetch,
        create,
        update,
        remove,
    },
    reducer: slice.reducer,
    selectors,
}